
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="2">
                    <v-text-field
                        label="CPF"
                        v-model="form.filters.cpf"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                        @paste.prevent="validarPegarNumeros"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        label="Nome do usuário"
                        v-model="form.filters.nome"
                        outlined
                        dense
                        maxlength="252"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        label="Perfil"
                        :items="form.lists.listPerfis"
                        item-text="nome"
                        item-value="id"
                        v-model="form.filters.perfis"
                        outlined
                        dense
                    ></v-autocomplete>
                </v-col>
                <sigfoco-select-ativo
                    :cols="2"
                    v-model="form.filters.situacao"
                    labelType="Situação"
                ></sigfoco-select-ativo>
                
            </v-row>
            <v-row class="d-flex justify-center mt-3">
                <sigfoco-date-picker
                    :cols="2"
                    label="Data Início"
                    v-model="form.filters.dataInicio"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
                <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFim"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
            </v-row>
             <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarRelatorios"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="headersAnalitico"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          sort-by="dataHoraDaAcao"
          :sort-desc="true"
          show-expand
          item-key="eventoId"
          :expanded.sync="expanded"
        >
            <template v-slot:[`item.cpf`]="{ item }">
                {{ $esconderCpf(item.cpf) }}
            </template>
            <template v-slot:[`item.nome`]="{ item }">
                {{ item.nome }}
            </template>
            <template v-slot:[`item.perfis`]="{ item }">
             {{ item.perfis }}
            </template>
            <template v-slot:[`item.email`]="{ item }">
                {{ item.email }}
            </template>
            <template v-slot:[`item.situacao`]="{ item }">
                <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
            </template>
            <template class="report" v-slot:[`item.usuarioDaAlteracao`]="{ item }">
                {{ item.usuarioDaAlteracao }}
            </template>
            <template v-slot:[`item.dataHoraDaAcao`]="{ item }">
                {{ $formatarDataHora(item.dataHoraDaAcao) }}
            </template>
            <template v-slot:[`item.acao`]="{ item }">
                {{ item.acao }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
            <td class="perfis" :colspan="headers.length">
              <v-chip-group active-class="primary--text" column>
                <v-chip
                  class="chip-permissao"
                  v-for="(perfil, i) in item.perfil"
                  :key="i"
                >
                  <v-icon class="perfil" small>mdi-account-multiple</v-icon>
                  {{ perfil.nomeDeExibicao }}
                </v-chip>
              </v-chip-group>
            </td>
          </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioDeLog from "services/relatorios-log/manter-usuario-log.service"
    import PerfilService from "services/manter-perfil.service";
    export default {
        name: "RelatorioLogUsuario",
        mixins: [pageLoadingMixin, RelatorioDeLog, PerfilService],
    
        data: () => ({
        onReport: false,
        expanded: [],
        form: {
            filters: {
                cpf: null,
                nome: null,
                perfis: null,
                email: null,
                situacao: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
                listGrupos: [],
                listPerfis: [],
            },
        },
        headersAnalitico: [
            { text: "CPF", align: "center", value: "cpf" },
            { text: "Nome do usuário", align: "center", value: "nome" },
            { text: "Perfil", align: "center", value: "data-table-expand" },
            { text: "E-mail", align: "center", value: "email" },
            { text: "Situação", align: "center", value: "situacao" },
            { text: "Data/Hora da ação", align: "center", value: "dataHoraDaAcao" },
            { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        validarPegarNumeros(event) {
            const textoPuro = event.clipboardData.getData('Text').replace(/\D/g, '');
            this.form.filters.cpf = textoPuro;
        },
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
    
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogUsuario(this.$montarParamsFilters(preparedRequest));
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },
    
        verificarFiltrosPreenchidos() {
          const { cpf, nome, situacao, perfis, dataInicio, dataFim } = this.form.filters;
          if (!cpf && !nome && situacao == null && perfis == null && !dataInicio && !dataFim) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
    
        async baixarCSVRelatorio() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVUsuario(this.$montarParamsFilters(preparedRequest));
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeUsuárioCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFUsuario(this.$montarParamsFilters(preparedRequest));
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeUsuário.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
        prepararRequisicao() {
            const unmaskCpf = this.form.filters.cpf?.replace(/\D/g, '');
            return {
            cpf: unmaskCpf,
            nome: this.form.filters.nome,
            perfilId: this.form.filters.perfis,
            dataInicio: this.form.filters.dataInicio,
            dataFim: this.form.filters.dataFim,
            ativo: this.form.filters.situacao,
            };
        },
    
        processarRespostaRelatorio(data) {
            this.form.lists.listRelatorios = data.relatorio?.logsUsuario;
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
          });
          this.form.filters.nome = null;
          this.form.filters.cpf = null;
          this.form.filters.perfis = null;
          this.form.filters.situacao = null;

          this.form.lists.listRelatorios = [];
          this.expanded = [];
        }
      },
      mounted() {
        this.$buscarPerfis({ params: { situacao: true } }).then(({ data }) => {
            this.form.lists.listPerfis = data.lista;
        });
    }
    };
</script>